import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledActionsWrap = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
`;

export const StyledActionButton = styled(Button)<{ $color: string }>`
  &&& {
    background: ${({ $color }) => $color};
    padding: 0.25rem 0.75rem;
    border: none;
    max-width: 8.125rem;
    min-width: 2.125rem;
    height: 2.125rem;
    color: ${COLORS.WHITE};
    ${pickThemeFontStyles('12', '14', 'BOLD')};

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;
